import React from 'react'

import {renderComponent} from 'helpers/landing'
import Section from 'components/UI/Section'

const LandingSection = ({content}) => {
  const {__typename} = content

  return (
    <>
      <Section hasRichTextPadding>
        {renderComponent(__typename, content)}
      </Section>
    </>
  )
}

export default LandingSection
